module.exports = __webpack_public_path__ + "img/11.f119738b.jpg";